// components
import { styled } from '@mui/material';

// external libraries
import { motion } from 'motion/react';

export const StyledUnsavedDataAlertBox = styled(motion.div)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'absolute',
  right: theme.spacing(9),
  padding: theme.spacing(0, 6),
  borderBottomLeftRadius: theme.shape.borderRadius,
  borderBottomRightRadius: theme.shape.borderRadius,
  backgroundColor: theme.vars.palette.Alert.warningStandardBg,

  '& .MuiPaper-root': {
    boxShadow: 'none !important'
  }
}));

export const StyledUnsavedDataAlertRepositioned = styled(
  StyledUnsavedDataAlertBox
)(({ theme }) => ({
  right: 0,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[1]
}));

export const StyledUnsavedDataAlertBoxRelative = styled(motion.div)(
  ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(0, 4),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.vars.palette.Alert.warningStandardBg,

    '& .MuiPaper-root': {
      boxShadow: 'none !important'
    }
  })
);
